import React from 'react'
import { Form, FormGroup } from 'react-bootstrap'
import { SelectableValue } from '../../components/page-components/selects-entities/generic-select/selectable-value'
import { Select } from '../../components/page-components/selects-entities/generic-select/Select'
import { useLazyGetUserQuery } from '../../store/kopiliot-api/user'
import {
  useAssignAlarmMutation,
  useGetAlarmQuery,
  useLazyGetAssignableUsersQuery,
} from '../../store/kopiliot-api/alarm'
import UserId from '../../shared/models/id/user-id'
import { AlarmID } from '../../shared/models/id/alarm-id'

interface Props {
  alarmID: AlarmID
}

const AssignUserToAlarm = ({ alarmID }: Props) => {
  const [getUsers, { data, isLoading, error }] =
    useLazyGetAssignableUsersQuery()
  const [getUser, { data: dataUser, isLoading: isLoadingUser }] =
    useLazyGetUserQuery()
  const { data: dataAlarm, isLoading: isLoadingAlarm } =
    useGetAlarmQuery(alarmID)
  const [selectedUser, setSelectedUser] =
    React.useState<SelectableValue<UserId>>()
  const [isUserSelected, setIsUserSelected] = React.useState(false)
  const [options, setOptions] = React.useState<SelectableValue<UserId>[]>([])
  const [assignToUser, { data: dataAssign, isLoading: isLoadingAssign }] =
    useAssignAlarmMutation()
  React.useEffect(() => {
    if (data) {
      setOptions(
        data.rows.map((user) => {
          return {
            label: `${user.firstname} ${user.lastname} (${user.email})`,
            value: user.id,
          }
        })
      )
    }
  }, [data])
  React.useEffect(() => {
    if (dataAlarm && dataAlarm.assignedUserID) {
      setSelectedUser({
        label: `test`,
        value: dataAlarm.assignedUserID,
      })
      getUser(dataAlarm.assignedUserID.id)
    }
  }, [dataAlarm?.assignedUserID])
  React.useEffect(() => {
    if (dataUser) {
      setOptions([
        {
          label: `${dataUser.firstname} ${dataUser.lastname} (${dataUser.email})`,
          value: dataUser.id,
        },
      ])
    }
  }, [dataUser])
  React.useEffect(() => {
    if (selectedUser && isUserSelected) {
      assignToUser({
        id: alarmID,
        assigneeID: selectedUser?.value,
      })
    }
  }, [selectedUser, isUserSelected])
  const onChange = (value: SelectableValue<UserId | null>) => {
    if (value.value) {
      assignToUser({
        id: alarmID,
        assigneeID: value.value,
      })
    }
  }
  const onInputChange = (value: string) => {
    getUsers({ textSearch: value, limit: 10, offset: 0, id: alarmID })
  }

  return (
    <FormGroup>
      <Form.Label className={'fs-8 text-body-emphasis'}>
        Assign user to alarm
      </Form.Label>
      <Select
        clearable={true}
        options={options}
        value={selectedUser}
        debounceDelay={1500}
        onInputChange={onInputChange}
        onChange={onChange}
        valueComparator={(a, b) => a?.value?.id === b?.value?.id}
      />
    </FormGroup>
  )
}

export default AssignUserToAlarm
